import { useTranslation } from 'next-i18next';
import { trackMixpanelEvent } from 'utils/analytics';

import {
  AddPropertyField,
  PropertyFieldsTable,
} from '@/modules/settings/property';
import { ActionTabHeader } from '@/modules/settings/shared/components/ActionTabHeader';
import { Typography } from '@/shared/components/atoms';
import { useAuth } from '@/shared/hooks/context/auth';
import { useStore } from '@/shared/hooks/context/createGenericContext';
import { useModal } from '@/shared/hooks/context/modalContext/useModal';

const PropertyFields = () => {
  const { t } = useTranslation();
  const { openModal } = useModal();
  const { user } = useAuth();

  const [selectedAsset] = useStore((store) => store?.asset);

  const onClick = () => {
    trackMixpanelEvent('Add Field Setting Page', user);
    openModal(<AddPropertyField selectedAsset={selectedAsset} />, {
      variant: 'full',
      title: <Typography variant='h2'>{t('fields-and-crops')}</Typography>,
    });
  };

  return (
    <div>
      <ActionTabHeader
        onClick={onClick}
        title={t('work-locations')}
        description={t(
          'The field unit with its crop variety will be the central unit for all data recording, reporting and costing. For fields with rotational crops, you can then archive them and create new ones.'
        )}
        actionTitle={t('Create New Field')}
      />
      <div className=' mt-48'>
        <PropertyFieldsTable />
      </div>
    </div>
  );
};

export default PropertyFields;
